export default "/WebApp/dist/assets/svg/newplus-disabled.svg";